import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M9.5 0.5C14.45 0.5 18.5 4.55 18.5 9.5C18.5 14.45 14.45 18.5 9.5 18.5C4.55 18.5 0.5 14.45 0.5 9.5C0.5 4.55 4.55 0.5 9.5 0.5ZM9.5 2.3C7.79 2.3 6.26 2.84 5.09 3.83L15.17 13.91C16.07 12.65 16.7 11.12 16.7 9.5C16.7 5.54 13.46 2.3 9.5 2.3ZM13.91 15.17L3.83 5.09C2.84 6.26 2.3 7.79 2.3 9.5C2.3 13.46 5.54 16.7 9.5 16.7C11.21 16.7 12.74 16.16 13.91 15.17Z"
      fill="#222A5C"
    />
  </svg>,
  "OptOut"
);
